"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.compile = exports.compileVerbose = void 0;
const parser_1 = require("./parser");
const semantics_1 = require("./semantics");
const codeGeneration_1 = require("./codeGeneration");
const util_1 = require("./util");
function compileVerbose(source) {
    const parserResult = parser_1.parse(source);
    if (util_1.isFailure(parserResult)) {
        return util_1.failure(parserResult.error);
    }
    const ast = parserResult.value;
    const types = semantics_1.check(ast);
    if (util_1.isFailure(types)) {
        return util_1.failure(types.error);
    }
    const code = codeGeneration_1.generateJs(ast);
    if (util_1.isFailure(code)) {
        return util_1.failure(`Code Generation Error: ${code.error}`);
    }
    return util_1.success({
        ast,
        types: types.value,
        code: code.value,
    });
}
exports.compileVerbose = compileVerbose;
function compile(source) {
    const result = compileVerbose(source);
    return util_1.isSuccess(result) ? util_1.success(result.value.code) : util_1.failure(result.error);
}
exports.compile = compile;
//# sourceMappingURL=index.js.map